import { render, staticRenderFns } from "./Friends.vue?vue&type=template&id=c265e8f4&scoped=true"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"
import style0 from "./Friends.vue?vue&type=style&index=0&id=c265e8f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c265e8f4",
  null
  
)

export default component.exports